export default "__VITE_ASSET__DFA_OTR7__"